export default {
  'fileView.batchDescription': 'Batch Description',
  'fileView.batchInformation': 'Batch Information',
  'fileView.batchNumber': 'Batch Number',
  'fileView.errorDetails': 'Error Details',
  'fileView.effectiveDate': 'Effective Date',
  'fileView.secCode': 'Sec Code',
  'fileView.selectBatch': 'Select Batch Number',
  'fileView.serviceType': 'Service Type',
  'fileView.summary': 'File Summary',
  'fileView.totalBatches': 'Total Batches',
  'fileView.warningDetails': 'Warning Details',
  'fileView.grid.idName': 'ID Number',
  'fileView.grid.typeOfItem': 'Type of item',
  'fileView.grid.debitCredit': 'Debit/Credit',
  'fileView.allReceivers': 'All Receivers'
};
